import React from 'react';
import clsx from 'clsx';
import { Theme } from '@mui/material/styles';
import Apple from '@mui/icons-material/Apple';
import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import YouTube from '@mui/icons-material/YouTube';
import Soundcloud from 'mdi-material-ui/Soundcloud';
import Spotify from 'mdi-material-ui/Spotify';
import useStyles from './styles';
import { SocialMediaType } from '../../types/socialMedia';
import { SizeVariant } from '../../types/variants';

export type SocialIconLinkPropTypes = {
  type: SocialMediaType;
  href: string;
  variant: SizeVariant;
  color?: string;
};
const SocialIconLink = ({ type, variant, href, color }: SocialIconLinkPropTypes) => {
  const { classes } = useStyles();

  const formattedHref = '//' + href.replace('https://', '').replace('www.', '');

  const variantClassMap = {
    large: classes.large,
    medium: classes.medium,
    small: classes.small,
  } as const;

  const iconMap = {
    facebook: Facebook,
    instagram: Instagram,
    soundcloud: Soundcloud,
    twitter: XIcon,
    x: XIcon,
    youtube: YouTube,
    appleMusic: Apple,
    spotify: Spotify,
  } as const;

  const getIcon = () => {
    const iconClassName = clsx(variantClassMap[variant]);

    // Apply color: use color prop if provided, otherwise default to theme.palette.text.primary
    const iconSx = {
      color: color || ((theme: Theme) => theme.palette.text.primary),
    };

    const IconComponent = iconMap[type];
    if (!IconComponent) {
      console.error(`Unrecognized Social Media Type: ${type}`);
      return null;
    }

    return <IconComponent className={iconClassName} sx={iconSx} />;
  };

  return (
    <a
      href={formattedHref}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.root}
    >
      {getIcon()}
    </a>
  );
};

export default SocialIconLink;
